import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ZpmProxySettings } from '../../shared/models/generated/ziroModels';

@Injectable({ providedIn: 'root' })
export class MicrosoftProxyFeatureSettingsResource {
  private http = inject(HttpClient);

  private _baseUrl = '/services/microsoft/admin/proxy-feature-settings';

  get(): Observable<ZpmProxySettings> {
    return this.http.get<ZpmProxySettings>(this._baseUrl);
  }

  put(body: ZpmProxySettings): Observable<ZpmProxySettings> {
    return this.http.put<ZpmProxySettings>(this._baseUrl, body);
  }
}
